import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: '2D_distance_between_points',
    dependencies: [
        'levels_maths/distance_to_origin', //FIXME distanceToOrigin
        'levels_maths/vector_from_points',
        'levels_maths/vector_length'
    ]
})


function squareDistance (a, b) {
    return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2)
}


function common (q, params) {
    params = params || {}

    let a = {
        x: random.fairChoiceInt(1, 5, {name: 'ax'}),
        y: random.fairChoiceInt(1, 5, {name: 'ay'}),
        name: 'A'
    }

    let b = {
        x: a.x + random.fairChoiceInt(1, 5, {name: 'vx'}),
        y: a.y + random.fairChoiceInt(1, 5, {name: 'vy'}),
        name: 'B'
    }

    if (!params.noScreen) {
        let geoScreen = q.addGeoScreen()
        geoScreen.addPolygon({points: [a, b], displayPoints: true})
    }

    q.addText(mathText.point(a))
    q.addText(mathText.point(b))
    q.addText(mathText.pointsDistance(a, b) + ' ?')
    q.answer = [
        'racine(' + squareDistance(a, b) + ')',
        q.approximation(Math.sqrt(squareDistance(a, b)), 0.1)
    ]
}


level.addQuestion({
    generator: function (q) {
        common(q)
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        common(q, {noScreen: true})
    },
    times: 2
})


export default level

